class FilterBarController {

    constructor(
        appConfig,
        CommonRequest,
        FacilitySettings
    ){
        'ngInject';

        this.appConfig = appConfig;
        this.CommonRequest = CommonRequest;
        this.FacilitySettings = FacilitySettings;
    }

    $onInit() {
        this.yearList = this.CommonRequest.getYearList();
        this.monthList = this.CommonRequest.getMonthList();
        this.reportUrl = '';
        this.selectedClient = null;
        this.selectedCountry = null;
        this.selectedCampus = null;
        this.selectedFacility = null;
        this.selectedYear = null;
        this.selectedMonth = null;
    }

    /***
     * Set the campus for filtering the form. Setting this unsets all of the subsequent elements,
     * grabs a list of facilities for this campus, and allows the user to select a facility.
     *
     * @param campus    the selected campus.
     */
    setCampus(campus) {
        this.selectedCampus = campus;
        this.selectedFacility = null;
        this.selectedYear = null;
        this.selectedMonth = null;

        this.onFilterChange();
        this.updateFacilityList();
    }

    /***
     * Set the client for filtering the form. Setting this unsets all of the subsequent elements,
     * grabs a list of countries for this client (countries that contain a campus that belongs to
     * this client), and allows the user to select a country.
     *
     * @param client    the selected client.
     */
    setClient(client) {
        this.selectedClient = client;
        this.selectedCountry = null;
        this.selectedCampus = null;
        this.selectedFacility = null;
        this.selectedYear = null;
        this.selectedMonth = null;

        this.onFilterChange();
        this.updateCountryList();
    }

    /***
     * Set the country for filtering the form. Setting this unsets all of the subsequent elements,
     * grabs a list of campuses for the given client/country combination, and allows the user to
     * select a campus.
     *
     * @param country   the selected country.
     */
    setCountry(country) {
        this.selectedCountry = country;
        this.selectedCampus = null;
        this.selectedFacility = null;
        this.selectedYear = null;
        this.selectedMonth = null;

        this.onFilterChange();
        this.updateCampusList();
    }

    /***
     * Set the facility for filtering the form. Setting this unsets all of the subsequent elements
     * and allows the user to select a year.
     *
     * @param facility  the selected facility.
     */
    setFacility(facility) {
        this.selectedFacility = facility;
        this.selectedYear = null;
        this.selectedMonth = null;

        this.onFilterChange();
    }

    /***
     * Sets the month for filtering the form. Setting this calls the callback function that grabs
     * the form that matches the given facility/month/year combination.
     *
     * @param month     the selected month.
     */
    setMonth(month) {
        this.selectedMonth = month;
        this.onFilterChange();

        // Set the localization settings based upon the facility's country and set them locally
        this.FacilitySettings.setLocalizationUnits(this.selectedFacility);

        this.onFormSelect({
            clientId: this.selectedClient.id,
            countryId: this.selectedCountry.id,
            campusId: this.selectedCampus.id,
            facilityId: this.selectedFacility.id,
            month: this.selectedMonth.id,
            year: this.selectedYear.name
        });

        this.reportUrl = `${this.appConfig.apiUrl}/report/monthly-engagement/`
            + `?client=${this.selectedClient.id}`
            + `&country=${this.selectedCountry.id}`
            + `&campus=${this.selectedCampus.id}`
            + `&facility=${this.selectedFacility.id}`
            + `&year=${this.selectedYear.name}`
            + `&month=${this.selectedMonth.id}`
    }

    /***
     * Set the year for filtering the form. Setting this unsets all of the subsequent elements and
     * allows the user to select a month.
     *
     * @param year      the selected year.
     */
    setYear(year) {
        this.selectedYear = year;
        this.selectedMonth = null;

        this.onFilterChange();
    }

    /***
     * Grab the list of campuses that belong to the given client and country combination.
     */
    updateCampusList() {
        this.CommonRequest.getCampusesByClientAndCountry(
            this.selectedClient.id,
            this.selectedCountry.id)
            .then((successResponse) => {
                this.campusList = successResponse.data;
                if (this.campusList.length === 1) {
                    this.setCampus(this.campusList[0]);
                }
            });
    }

    /***
     * Grab the list of countries that contain a campus belonging to the given client.
     *
     * For example, if client A has 2 campuses, C1 (in Canada) and C2 (in Brazil), when client A
     * is selected, a list containing [Canada, Brazil] is returned.
     */
    updateCountryList() {
        this.CommonRequest.getCountriesByClient(this.selectedClient.id)
            .then((successResponse) => {
                this.countryList = successResponse.data;
                if (this.countryList.length === 1) {
                    this.setCountry(this.countryList[0]);
                }
            });
    }

    /***
     * Grab the list of facilities that belong to the given campus.
     */
    updateFacilityList() {
        this.CommonRequest.getFacilitiesByCampus(this.selectedCampus.id)
            .then((successResponse) => {
                this.facilityList = successResponse.data;
                if (this.facilityList.length === 1) {
                    this.setFacility(this.facilityList[0]);
                }
            });
    }

}

export default FilterBarController;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/filter-bar/filter-bar-controller.js